<template>
  <a-modal
    :visible="visible"
    :title="$t('page_ops_customer_build_tenant')"
    :destroyOnClose="true"
    :width="680"
    :closable="false"
  >
    <template slot="footer">
      <a-button key="close" @click="close">
        {{ $t('cancel') }}
      </a-button>
      <a-button key="prev" @click="prev" v-if="step > 0">
        {{ $t('page_ops_customer_prev_step') }}
      </a-button>
      <a-button key="submit" type="primary" @click="next">
        {{ okText }}
      </a-button>
    </template>

    <a-steps :current="step">
      <a-step>
        <template slot="title">
          {{ $t('page_ops_customer_basic_info') }}
        </template>
        <span slot="description">{{ $t('page_ops_customer_necessary_improve') }}</span>
      </a-step>
      <a-step
        :title="$t('page_ops_customer_tenant_authorization')"
        :description="$t('page_ops_customer_authorize_apps_new_tenants')"
      />
      <a-step
        :title="$t('page_ops_customer_shared_device')"
        :description="$t('page_ops_customer_share_devices_with_tenants')"
      />
    </a-steps>

    <br />

    <a-form
      v-show="step == 0"
      ref="turnToTenantModel"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :form="form"
    >
      <a-form-item :label="$t('page_ops_customer_tenant_number')">
        <a-input
          v-decorator="[
            'tenantCode',
            {
              initialValue: formData.namePinyinShort,
              rules: [
                {
                  required: true,
                  message: $t('page_tenant_please_enter_tenant_number')
                },
                {
                  validator: validateCode
                }
              ]
            }
          ]"
          :placeholder="$t('common_please_input') + $t('page_tenant_please_enter_tenant_number')"
        />
      </a-form-item>
      <a-form-item :label="$t('page_ops_customer_tenant_name')">
        <a-input
          v-decorator="[
            'tenantName',
            {
              initialValue: formData.name,
              rules: [
                {
                  required: true,
                  message: $t('page_tenant_please_enter_tenant_name')
                }
              ]
            }
          ]"
          :placeholder="$t('common_please_input') + $t('page_tenant_please_enter_tenant_name')"
        />
      </a-form-item>
      <a-form-item :label="$t('page_ops_customer_contacts')">
        <a-input
          v-decorator="[
            'linkman',
            {
              initialValue: formData.contact,
              rules: [
                {
                  required: true,
                  message: $t('page_tenant_please_enter_contact')
                }
              ]
            }
          ]"
          :placeholder="$t('common_please_input') + $t('page_tenant_please_enter_contact')"
        />
      </a-form-item>
      <a-form-item :label="$t('page_ops_customer_phone')">
        <a-input
          v-decorator="[
            'contactNumber',
            {
              rules: [
                {
                  required: true,
                  message: $t('page_tenant_input_the_correct_mobile_number')
                },
                {
                  validator: validatePhone
                }
              ],
              initialValue: formData.tel
            }
          ]"
          :placeholder="$t('common_please_input') + $t('page_tenant_enter_your_mobile_number')"
        />
      </a-form-item>
    </a-form>
    <div v-show="step == 1">
      <a-table :columns="columns" :data-source="data" :pagination="false">
        <a-switch
          slot="switch"
          default-checked
          @change="(e) => onChange(code, e)"
          slot-scope="code"
          size="small"
        />
      </a-table>
    </div>

    <div v-show="step == 2">
      <a-alert
        :message="$t('page_ops_customer_after_share_mesg')"
        type="info"
        show-icon
        style="margin-bottom: 8px"
      />
      <a-transfer
        :data-source="mockData"
        :list-style="{
          width: '285px',
          height: '400px',
          overflow: 'auto'
        }"
        :showSelectAll="true"
        :titles="[
          $t('page_ops_customer_no_shared_devices'),
          $t('page_ops_customer_is_shared_devices')
        ]"
        showSearch
        :target-keys="targetKeys"
        :render="renderItem"
        @change="handleChange"
      />
    </div>
  </a-modal>
</template>

<script>
import { isCellphoneNo } from '@/utils/validate'
import { MasterlinkTenantServiceProxy,AppServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { CustomerServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
import { MachineServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'

const appService = new AppServiceProxy()
const tenantService = new MasterlinkTenantServiceProxy()
const customerService = new CustomerServiceProxy()
const msp = new MachineServiceProxy()

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      step: 0,
      okText: '',
      data: [],
      columns: [
        {
          title: '',
          dataIndex: 'code',
          key: 'switch-code',
          scopedSlots: { customRender: 'switch' },
          width: 80
        },
        {
          title: this.$t('page_ops_customer_app_number'),
          dataIndex: 'code',
          key: 'code',
          width: 240
        },
        {
          title: this.$t('page_ops_customer_app_name'),
          dataIndex: 'displayName',
          key: 'adisplayName',
          ellipsis: true
        }
      ],
      appload: false,
      authorizeAppCodes: [],
      newTenant: {},
      mockData: [],
      targetKeys: []
    }
  },
  created() {
    this.step = 0
    this.refreshNextText()
  },
  methods: {
    onChange(item, checked) {
      if (checked) {
        this.authorizeAppCodes.push(item)
      } else {
        this.authorizeAppCodes = this.authorizeAppCodes.filter((x) => x !== item)
      }
    },
    async validateCode(rule, value, cb) {
      if (/^[a-zA-Z][\w_-]{2,11}$/.test(value)) {
        const result = await tenantService.tenantExist(value)
        if (result.data) {
          cb(this.$t('page_ops_customer_tenant_has_exists'))
        } else {
          cb()
        }
      } else {
        cb(this.$t('page_tenant_input_code_tip'))
      }
    },
    validatePhone(rule, value, callback) {
      if (!isCellphoneNo(value)) {
        callback(this.$t('page_tenant_input_the_correct_mobile_number'))
      }
      callback()
    },
    prev() {
      if (this.step === 0) return
      this.step = this.step - 1
      this.refreshNextText()
    },
    next() {
      if (this.step === 0) {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.step = this.step + 1
            this.refreshNextText()
            this.newTenant = values

            if (!this.appload) {
              appService.page('2', '', 1, '', -1).then((res) => {
                this.appload = true
                this.data = res.records.filter(
                  (x) => x.code !== 'console' && x.code !== 'ops'
                )
                this.authorizeAppCodes = this.data.map((x) => x.code)
              })
            }
          }
        })
      }

      if (this.step === 1 && this.authorizeAppCodes.length > 0) {
        this.step = this.step + 1
        this.refreshNextText()
        this.getCustomerMachineList()
        return
      }

      if (this.step === 2 && this.authorizeAppCodes.length > 0) {
        // this.step = this.step + 1;
        // this.refreshNextText();
        this.doSubmit()
        return
      }
    },
    async getCustomerMachineList() {
      this.mockData = []
      this.targetKeys = []
      const list = await this.getMachineList()
      this.mockData = list.map((res) => {
        const data = {
          key: res.id,
          title: res.name,
          description: res.code,
          isShared: res.isShared
        }
        if (res.isShared) {
          this.targetKeys.push(res.id)
        }
        return data
      })
    },
    async getMachineList() {
      const filter = {
        customerId: this.formData.id,
        isAssigned: true,
        assemblyState: '',
        deviceTypeId: ''
      }
      return await (await msp.getMachineList(1, filter, -1)).records
    },
    reset() {
      this.appload = false
      this.step = 0
      this.data = []
      this.appload = false
      this.authorizeAppCodes = []
      this.newTenant = {}
      this.mockData = []
      this.targetKeys = []
      this.refreshNextText()
    },
    close() {
      this.reset()
      this.$emit('close')
    },
    refreshNextText() {
      this.okText =
        this.step < 2 ? this.$t('page_ops_customer_next_step') : this.$t('page_ops_customer_submit')
    },
    doSubmit() {
      customerService
        .turnToTenant(
          null,
          this.authorizeAppCodes,
          2,
          this.newTenant.contactNumber,
          null,
          this.newTenant.linkman,
          this.newTenant.tenantCode,
          null,
          this.newTenant.tenantName,
          this.formData.id
        )
        .then((res) => {
          this.moveMachine(res.data)
        })
    },
    async moveMachine(data) {
      const input = {
        targetTenantId: data.tenantId,
        workStationIdList: this.targetKeys,
        unsharedWorkStationIdList: []
      }
      await msp.shareMachine(input)
      this.reset()
      this.$emit('close', true)
      this.warning(data.tenantCode)
    },
    warning(tenantCode) {
      this.$warning({
        title: this.$t('page_ops_customer_tenant_success'),
        content:
          this.$t('page_ops_customer_through_enterprise') +
          `${tenantCode},` +
          this.$t('page_ops_customer_login_with_the')
      })
    },
    renderItem(item) {
      const customLabel = (
        <span class="custom-item">
          {item.title} - {item.description}
        </span>
      )

      return {
        label: customLabel, // for displayed item
        value: item.title // for title and filter matching
      }
    },
    handleChange(targetKeys) {
      this.targetKeys = targetKeys
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-transfer-operation .ant-btn:first-child {
  margin-bottom: 16px;
}
/deep/ .ant-btn-icon-only.ant-btn-sm {
  width: 34px;
  height: 34px;
  padding: 0;
  font-size: 14px;
  border-radius: 0;
}
</style>
